import * as clsApi from "./classroomApi";

export const SCREEN_SHARE_FEATURE_FLAG = "SCREEN_SHARE";

export type GetEnabledFeaturesResponse = {
	applianceId: string;
	enabledFeatures: string[];
};

export async function getEnabledFeatures(applianceId: string): Promise<GetEnabledFeaturesResponse> {
	return await clsApi.Get2<GetEnabledFeaturesResponse>(`v1/appliances/${applianceId}/enabled-features`);
}
